import React from 'react'
import './Plans.css'
import whiteTick from '../../assets/whiteTick.png' // Assuming you have a whiteTrick.png file in your assets folder
import { plansData } from '../../data/plansData' // Assuming you have a plansData.js file with your plans data
const Plans = () => {
    return (
        <div className="Plans">
            <div className="programs-header" style={{
                display: 'flex',
                color: 'gray',
                fontSize: '4rem',
                gap: '5rem',
                justifyContent: 'center',
                alignItems: 'center',
            }}>
                <span className='stroke-text'>ready-to-start</span>
                <span>yout </span>
                <span className='stroke-text'>ipbvojf vk</span>
            </div>
            <div className="blur planblur"></div>
            <div className="blur planblur1"></div>
            {/* plans card */}
            <div className="plans">
                {plansData.map((p, i) => (
                    <div className="plan" key={i}>
                        {p.icon}
                        <span>{p.name}</span>
                        <span>$ {p.price}</span>
                        <div className="features">
                            {p.features.map((feature, j) => (
                                <div className="feature" key={j}>
                                    <img src={whiteTick} alt="" />
                                    <span key={i}>{feature}</span>
                                </div>
                            ))}
                        </div>
                        <div>
                            <span>see more benefits </span>
                        </div>
                        <button className="btn">Join Now</button>


                    </div>
                ))}

            </div>
        </div>
    )
}
// But gap only works on flex or grid containers — and in your code:
export default Plans
